import { Divider } from 'antd';
import CheckCircle from '../../assets/CheckCircle';

const WhiteCard = ({ index, account, handleSubmit, type }) => {
    return (
        <div key={index} className='w-[300px] flex flex-col border-2 border-light rounded-lg bg-white p-5'>
            <div>
                <div className="flex justify-center items-center bg-[#E5F1F2] w-[45px] h-[45px] rounded-lg mb-3">
                    <span className='text-xl font-semibold text-[#00727D]'>{index}</span>
                </div>

                <h1 className='text-2xl font-semibold primary capitalize mb-1'>{account?.planName}</h1>

                <p className='text-sm font-medium text-gray-500'>{account?.description || 'For experienced traders'}</p>
            </div>

            <Divider className='my-5' />

            <div className='flex-1 flex flex-col justify-between gap-8'>
                <div className='space-y-3 font-medium text-gray-500'>
                    {type === 'live' && (
                        <div className='flex items-center gap-2'>
                            <CheckCircle />
                            <p>${account?.minimumDeposit} Minimum Deposit</p>
                        </div>
                    )}

                    <div className='flex items-center gap-2'>
                        <CheckCircle />
                        <p>{account?.spread} Pips Spread</p>
                    </div>

                    {account?.swapFree && (
                        <div className='flex items-center gap-2'>
                            <CheckCircle />
                            <p>Swap free</p>
                        </div>
                    )}

                    <div className='flex items-center gap-2'>
                        <CheckCircle />
                        <p>{account?.marginCall}% Margin Call</p>
                    </div>

                    <div className='flex items-center gap-2'>
                        <CheckCircle />
                        <p>{account?.leverage}x Leverage</p>
                    </div>
                </div>

                <div className='flex justify-center'>
                    <button
                        className='bg-primary text-sm text-white font-semibold px-8 py-2 capitalize rounded-lg themeHover duration-500'
                        onClick={() => handleSubmit(account)}
                    >
                        {`Open ${type} Account`}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default WhiteCard
